// Xodim profili, ru
export default {
  noAccess: "Профиль недоступен",
  noAccessDesc: "Этот сотрудник вне вашего филиала, или профиля не существует.",
  breadcrumb: "Сотрудники",
  tabs: { overview: "Обзор", drivers_one: "Водители ({{count}})", drivers_few: "Водители ({{count}})", drivers_many: "Водители ({{count}})", drivers_other: "Водители ({{count}})", pay: "Зарплата и бонусы", activity: "Активность" },
  unblocked: "{{name}} разблокирован",
  username: "Логин",
  blocked: "Заблокирован",
  you: "Вы",
  noBranch: "Без филиала",
  manager: "Менеджер:",
  since: "В системе с {{date}}",
  lastLogin: "последний вход {{when}}",
  neverLoggedIn: "ещё не входил",
  twofaOn: "2FA включена",
  showDrivers: "Показать водителей",
  unblock: "Разблокировать",
  block: "Заблокировать",
  results: "Результаты · {{month}}",
  kpi: {
    hires: "Наймы (одобренные)",
    prev: "прошлый месяц: {{count}}",
    submitted: "Отправлено перевозчикам",
    waitingReply_one: "{{count}} ждёт ответа",
    waitingReply_few: "{{count}} ждут ответа",
    waitingReply_many: "{{count}} ждут ответа",
    waitingReply_other: "{{count}} ждут ответа",
    newDrivers: "Новые водители",
    calls: "Звонки",
    activities_one: "всего {{count}} действие",
    activities_few: "всего {{count}} действия",
    activities_many: "всего {{count}} действий",
    activities_other: "всего {{count}} действия",
    inPipeline: "Сейчас в воронке",
    pendingHires_one: "{{count}} найм ждёт одобрения",
    pendingHires_few: "{{count}} найма ждут одобрения",
    pendingHires_many: "{{count}} наймов ждут одобрения",
    pendingHires_other: "{{count}} найма ждут одобрения",
    timeToHire: "Среднее время найма",
    prevValue: "прошлый месяц: {{value}}",
    retention30: "Удержание 30 дней",
    overdue: "Просроченные задачи",
    overdueSub: "нужно внимание",
    noOverdue: "всё вовремя",
  },
  trend: { title: "Последние 6 месяцев", subtitle: "отправленные и одобренные наймы по месяцам", submitted: "Отправлено", hires: "Наймы" },
  rank: "место в {{branch}} по наймам · из {{of}}",
  bonus: { supplement: "доплата", title: "Бонус за этот месяц", basis: "наймов: {{hires}} · удержано 30 дней: {{retained}}", estimate: "оценка" },
  pipeline: { title: "Воронка сейчас", subtitle_one: "{{count}} активный водитель", subtitle_few: "{{count}} активных водителя", subtitle_many: "{{count}} активных водителей", subtitle_other: "{{count}} активного водителя" },
  funnel: { title: "Воронка за месяц", subtitle: "сколько водителей дошло до каждого этапа" },
  retention: { title: "Удержание", subtitle: "нанятые водители, которые работают спустя N дней" },
  drivers: {
    empty: "Нет водителей",
    emptyDesc: "За этим сотрудником не закреплено активных водителей.",
    hint_one: "{{count}} водитель · правый клик по строке — действия",
    hint_few: "{{count}} водителя · правый клик по строке — действия",
    hint_many: "{{count}} водителей · правый клик по строке — действия",
    hint_other: "{{count}} водителя · правый клик по строке — действия",
    openList: "Открыть в списке водителей",
    cols: { name: "Имя", phone: "Телефон", state: "Штат", status: "Статус", lastContact: "Последний контакт", nextAction: "Следующий шаг" },
  },
  pay: {
    chartTitle: "Выплаты по месяцам",
    chartSubtitle: "зарплата и бонус, последние 6 месяцев",
    salary: "Зарплата",
    bonus: "Бонус",
    total12: "Выплачено за 12 месяцев",
    total12Sub: "учтённые зарплаты и бонусы",
    unpaidSub: "ещё {{amount}} пока не выплачено",
    salaries: "Зарплаты",
    noSalaries: "Записей о зарплате пока нет.",
    bonuses: "Бонусы",
    noBonuses: "Бонусов пока нет.",
    cols: { month: "Месяц", amount: "Сумма", status: "Статус", paidOn: "Дата выплаты" },
    paid: "Выплачено",
    unpaid: "Не выплачено",
    monthTitle: "Зарплата и бонус · {{month}}",
    monthHint: "месяц выбирается вверху страницы",
    notSet: "Не указана",
    paidOn: "Выплачено {{date}}",
    lastMonth: "в прошлом месяце: {{amount}}",
    setSalary: "Указать зарплату",
    changeAmount: "Изменить сумму",
    markPaid: "Отметить выплату",
    markUnpaid: "Снять отметку о выплате",
    paidLocked: "Выплаченную зарплату может вернуть только владелец",
    amount: "Сумма",
    note: "Примечание",
    notePlaceholder: "Примечание, например: банковский перевод",
    salarySaved: "Зарплата сохранена · {{name}}",
    markedPaid: "Выплата отмечена · {{name}}",
    markedUnpaid: "Отметка о выплате снята · {{name}}",
    bonusNone: "Не рассчитан",
    bonusEstimate_one: "Пока примерно {{amount}} · {{count}} найм",
    bonusEstimate_few: "Пока примерно {{amount}} · {{count}} найма",
    bonusEstimate_many: "Пока примерно {{amount}} · {{count}} наймов",
    bonusEstimate_other: "Пока примерно {{amount}} · {{count}} найма",
    calculateInBudget: "Рассчитать в Бюджет → Бонусы",
    adjust: "Скорректировать",
    approve: "Утвердить",
    adjustment: "Корректировка (+ или −)",
    adjustmentReason: "Причина, например: рекомендация",
    calculated: "Рассчитано по правилу: {{amount}}",
    calcLine: "рассчитано {{calculated}} · корректировка {{adjustment}}",
    bonusAdjusted: "Бонус скорректирован · {{name}}",
    bonusApproved: "Бонус утверждён · {{name}}",
    bonusPaid: "Выплата бонуса отмечена · {{name}}",
  },
  activity: {
    title: "Последняя активность",
    subtitle: "звонки и заметки этого сотрудника",
    empty: "Активности пока нет",
    emptyDesc: "Здесь появятся звонки и заметки, которые сотрудник записывает по водителям.",
    minutes: "{{count}} мин",
  },
  list: {
    title: "Сотрудники", team: "Команда",
    subtitle_one: "{{count}} сотрудник · {{period}}", subtitle_few: "{{count}} сотрудника · {{period}}", subtitle_many: "{{count}} сотрудников · {{period}}", subtitle_other: "{{count}} сотрудника · {{period}}",
    activity: { label: "Активность", all: "Любая активность", quiet_one: "Тишина {{count}}+ день", quiet_few: "Тишина {{count}}+ дня", quiet_many: "Тишина {{count}}+ дней", quiet_other: "Тишина {{count}}+ дня", never: "Ни разу не активен" },
    newUser: "Новый сотрудник", search: "Поиск по имени или логину", showBlocked: "Показать заблокированных",
    roles: { all: "Все", recruiter: "Рекрутеры", branch_manager: "Менеджеры", owner: "Владелец" },
    cols: { person: "Сотрудник", scope: "Филиал", drivers: "Активные водители", new: "Новые", submitted: "Отправлено", hired: "Нанято", conv: "Конв.", calls: "Звонки", last: "Последняя активность", overdue: "Просрочено" },
    empty: "Никто не подходит под фильтры.", never: "Активности ещё нет", blocked: "Заблокирован", hint: "Клик по строке — страница сотрудника. Результаты за период считаются по истории статусов.",
  },
};
